import React, { memo } from "react";
import dynamic from "next/dynamic";

import SolidArrowIcon from "components/Icons/arrows/SolidArrowIcon";
import ChatBubbleIcon from "components/Icons/chat_bubble.svg";

// Import chat as its own bundle to keep socket-io out of main vendor bundle
const ChatInit = dynamic(() => import("./ChatInit"), { ssr: false });

// This is a string due to the fact there is a lot of incongruent react syntax in this original pug
// template, and we are erring on safety / caution with the initial port since this will go away completely
// with a port to React anyway.
const template = `
<div
  class="chat--card"
  id="{{placeholder-id}}"
  style="align-self: flex-start"
>
  <div
    class="chat--collapsed p-lg bg-yellow-{{tab-opacity}} rounded-t-sm"
    id="collapsed-window"
  >
    <div class="chat--header text-charcoal">
      <div class="text-sm font-bold chat--dispensary">
        Chat With {{dispensary-name}}
      </div>
      <div class="text-xs status-message"></div>
    </div>
    <div style="align-self: center; position: relative">
      <button
        class="chat--button bg-yellow"
        id="chatButton"
        aria-label="chat with dispensary"
        height="32px"
        width="32px"
      >
        <svg height="32px" width="32px" title="message" viewBox="0 0 24 24">
          <path stroke="#333333" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" fill="none" d="M18.5825 20.2281V4.86894C18.5825 4.57797 18.4669 4.29892 18.2612 4.09318C18.0554 3.88744 17.7764 3.77185 17.4854 3.77185H6.51457C6.2236 3.77185 5.94455 3.88744 5.73881 4.09318C5.53307 4.29892 5.41748 4.57797 5.41748 4.86894V20.2281L7.61165 18.034L9.80583 20.2281L12 18.034L14.1942 20.2281L16.3883 18.034L18.5825 20.2281Z"/>
          <path stroke="#333333" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"             d="M8.58252 7.99988H15.5825"/>
          <path stroke="#333333" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"             d="M8.58252 10.9999H15.5825"/>
          <path stroke="#333333" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"             d="M8.58252 13.9999H15.5825"/>
        </svg></button
      ><span
        class="button-badge bg-error text-white text-xs font-extrabold hidden"
        id="chat-button-badge"
      ></span>
    </div>
  </div>
  <div
    class="chat--expanded bg-leafly-white shadow-low"
    id="expanded-window"
    style="flex-direction: column"
  >
    <div
      class="bg-white p-lg"
      style="
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        border-bottom: 1px solid #e7e7e7;
      "
    >
      <div style="flex-direction: column">
        <div class="text-charcoal text-sm chat--dispensary">
          Chat With {{dispensary-name}}
        </div>
        <div class="text-xs status-message"></div>
        <a
          class="text-xs text-green font-bold"
          href="/order-status/{{order-key}}"
          >View order details</a
        >
      </div>
      <div>
        <button
          class="p-xs ml-sm"
          id="close-chat-button"
          aria-label="close chat"
          style="align-self: start"
        >
          <svg height="16px" width="16px" title="close chat" viewBox="0 0 24 24">
           <path fill-rule="evenodd" clip-rule="evenodd" d="M11.75 10.689l6.47-6.47a.749.749 0 111.06 1.06l-6.47 6.47 6.47 6.47a.749.749 0 11-1.06 1.06l-6.47-6.468-6.47 6.469a.749.749 0 11-1.06-1.06l6.469-6.47-6.47-6.47a.749.749 0 111.06-1.06l6.47 6.469z" fill="currentColor"/>
          </svg>
        </button>
      </div>
    </div>
    <ul class="chat--messages-list pb-lg"></ul>
    <div class="bg-white p-sm chat--input items-end">
      <textarea
        class="bg-leafly-white p-xs font-gray overflow-y-hidden bg-white"
        data-testid="chat-input"
        aria-label="chat input"
        placeholder="Type here..."
        type="text"
        autocomplete="off"
      ></textarea
      ><button class="bg-yellow rounded-r" id="send-button" aria-label="send chat">
        <svg height="20px" width="20px" title="message" viewBox="0 0 24 24">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M8.5851 15.3319H5.1821C4.7621 15.3319 4.3541 15.1949 4.0191 14.9429C3.6841 14.6899 3.4401 14.3349 3.3241 13.9319C3.2081 13.5279 3.2271 13.0979 3.3771 12.7059C3.5281 12.3139 3.8021 11.9819 4.1571 11.7589L17.2991 3.54391C17.6181 3.34491 17.9881 3.24291 18.3641 3.24991C18.7391 3.25791 19.1051 3.37491 19.4151 3.58691C19.7251 3.79891 19.9671 4.09691 20.1111 4.44491C20.2541 4.79191 20.2931 5.17391 20.2231 5.54091C20.2231 5.54091 17.6641 19.1739 17.6631 19.1749C17.5941 19.5429 17.4191 19.8839 17.1591 20.1539C16.9001 20.4249 16.5671 20.6149 16.2021 20.6999C15.8371 20.7849 15.4551 20.7619 15.1031 20.6329C14.7501 20.5049 14.4431 20.2769 14.2181 19.9779L13.2741 18.7179L11.6061 19.8549C11.3161 20.0529 10.9771 20.1679 10.6261 20.1879C10.2751 20.2079 9.9251 20.1319 9.6141 19.9669C9.3041 19.8029 9.0441 19.5569 8.8621 19.2559C8.6811 18.9549 8.5851 18.6099 8.5851 18.2589V15.3319ZM18.6241 5.93091L12.0521 14.5849L15.4171 19.0769C15.4681 19.1439 15.5371 19.1949 15.6161 19.2239C15.6951 19.2529 15.7801 19.2579 15.8621 19.2389C15.9441 19.2199 16.0181 19.1769 16.0771 19.1159C16.1351 19.0559 16.1741 18.9799 16.1891 18.8969L18.6241 5.93091ZM10.0851 15.3319V18.2589C10.0851 18.3369 10.1061 18.4149 10.1471 18.4819C10.1881 18.5489 10.2461 18.6039 10.3151 18.6409C10.3851 18.6779 10.4631 18.6949 10.5421 18.6909C10.6201 18.6859 10.6961 18.6599 10.7611 18.6159L12.3731 17.5169L10.7371 15.3319H10.0851ZM10.7401 13.8319L17.1281 5.41991L4.9531 13.0309C4.8731 13.0809 4.8111 13.1559 4.7781 13.2429C4.7441 13.3309 4.7401 13.4279 4.7661 13.5179C4.7921 13.6089 4.8461 13.6879 4.9211 13.7449C4.9971 13.8009 5.0881 13.8319 5.1821 13.8319H10.7401Z" fill="#333333"/>
        </svg>
      </button>
    </div>
  </div>
</div>
`;

export default memo(() => (
  <>
    <div
      id="multiple-tabs"
      className="mt-sm chat--card"
      style={{
        alignSelf: "flex-start",
        display: "none",
      }}
    >
      <div className="chat--count p-lg bg-yellow-60 rounded-t-sm">
        <div className="chat--header text-default" style={{ width: "66%" }}>
          <div className="text-sm font-bold chat--dispensary">
            <span id="chat-count" className="align-middle"></span>
          </div>
        </div>
        <div
          style={{ alignSelf: "center", position: "relative" }}
          id="multiple-chat-icon"
          className="hidden"
        >
          <ChatBubbleIcon width="32" height="32" />
          <span
            id="multiple-button-badge"
            className="button-badge button-badge-multi bg-error text-white text-xs font-extrabold"
          ></span>
        </div>
        <div
          id="multiple-expand"
          style={{ alignSelf: "center", position: "relative" }}
        >
          <SolidArrowIcon height="32" width="32" direction="up" />
        </div>
        <div
          id="multiple-collapse"
          style={{
            alignSelf: "center",
            display: "none",
            position: "relative",
          }}
        >
          <SolidArrowIcon height="32" width="32" direction="down" />
        </div>
      </div>
    </div>
    <div className="relative h-full">
      <div
        id="message-container"
        className="chat--message-container overflow-y-scroll"
      ></div>
      <div
        className="hidden"
        id="message-template"
        dangerouslySetInnerHTML={{ __html: template }}
      ></div>
    </div>
    <ChatInit />
  </>
));
